import type { NodeEntry } from 'slate';
import { Editor, Transforms } from 'slate';

import type { LocationIdElement } from '../../internal';
import { generateLocationId, isLocationIdElement } from '../../internal';

/**
 * Backfill a missing locationId on a block element.
 */
export function backfillLocationId(editor: Editor, entry: NodeEntry<LocationIdElement>): void {
  const [node, path] = entry;
  if (node.locationId) return;

  Transforms.setNodes(
    editor,
    { locationId: generateLocationId() },
    {
      at: path,
      voids: true,
    }
  );
}

/**
 * Single document-order sweep over all document parts: backfills missing
 * locationIds and regenerates duplicates (the first occurrence keeps its id)
 */
export function ensureUniqueLocationIds(
  editor: Editor,
  options: { generateId?: () => string } = {}
): void {
  const { generateId = generateLocationId } = options;
  const seenIds = new Set<string>();

  const entries = Editor.nodes(editor, { at: [], match: isLocationIdElement, voids: true });
  for (const [node, path] of entries) {
    const { locationId } = node;
    if (locationId && !seenIds.has(locationId)) {
      seenIds.add(locationId);
      continue;
    }

    const newId = generateId();
    Transforms.setNodes(editor, { locationId: newId }, { at: path, voids: true });
    seenIds.add(newId);
  }
}
